<template>

<div>

  <div style="position: absolute; left: -5000px;" aria-hidden="true">
    <input
      type="text"
      name="b_cf87a768c977a161c3ec17e94_79064e04e6"
      tabindex="-1"
      value="">
  </div>

  <div class="clear">
    <input
      type="submit"
      :value="$t(item.text)"
      name="subscribe"
      id="mc-embedded-subscribe"
      class="button">
  </div>

</div>

</template>

<script>
export default {
  name: 'Common',
  props: {
    item: Object
  }
}
</script>

<style lang="scss" scoped>
input {
  width: 100%;
  color: #ffffff;
  font-size: 24px;
  text-align: right;
  font-family: 'Poppins-ExtraBold';
  font-weight: bold;
  text-transform: uppercase;
  background-color: inherit;
  border: none;
  cursor: pointer;
  margin-top: 50px;

  &:focus {
    outline: none;
  }
}
</style>
